import React, { useState } from "react";
import InputMask from "../../../components/InputMask";
import { Form } from "antd";
import { BtnLink, BtnPadrao } from "../../../components/Buttons";
import Mensagens from "../../../components/Mensagens";

const BuscarCep = ({ cep, setCep, onOk, required, disableForm, tabIndex, nextTab }) => {
  const [loading, setLoading] = useState(false);

  const handleGetCep = async () => {
    setLoading(true);
    onOk(await getCep(cep));
    setLoading(false);
  };

  return <div style={{ display: "flex" }}>
    {!disableForm ? <Form.Item name="cep" rules={[{ type: "string", message: "Insira o CEP", required: required, whitespace: true }]}>
      <InputMask
        placeholder="Insira o CEP"
        data-cy="input-cep"
        mask="99999-999"
        onKeyDown={e => {
          if (e.keyCode === 13)
            handleGetCep();
        }}
        value={cep}
        onChange={e => setCep(e.target.value)}
        tabIndex={tabIndex}
        nextTab={nextTab}
      />
    </Form.Item> : <InputMask
      placeholder="Insira o CEP"
      data-cy="input-cep"
      mask="99999-999"
      onKeyDown={e => {
        if (e.keyCode === 13)
          handleGetCep();
      }}
      onChange={e => setCep(e.target.value)}
      tabIndex={tabIndex}
      nextTab={nextTab}
    />}
    <BtnPadrao data-cy="btn-cep" style={{ marginLeft: 10 }} onClick={handleGetCep} loading={loading}>Buscar CEP</BtnPadrao>
    <BtnLink onClick={() => window.open("https://buscacepinter.correios.com.br/app/endereco/index.php?t")} style={{ padding: 5 }}>Não sei</BtnLink>
  </div>;
};

export default BuscarCep;

export const getCep = async cep => await fetch(`https://viacep.com.br/ws/${cep}/json/`)
  .then(res => res.json())
  .then(res => res?.cep ? res : Mensagens.showErro("cep não econtrado"))
  .catch(() => Mensagens.showErro("cep não encontrado"));